import React, { useEffect, useState } from 'react';
import CreateWidgets from './CreateWidgets';
import { websiteRegex } from '../../../../function/Regex';
import {
  generateWidgets,
  getWidgetsInfo,
  updateWidgets,
  getLogo
} from '../../../../api/AccountSetup';
import ToastNotification from '../../../../common/ToastNotification';
import { useNavigate } from 'react-router-dom';
import getCustomMenuEffect from '../../../../hooks/Menu';
import { stat } from 'fs';
interface WidgesProps {
  isSettings?: boolean | undefined;
}
interface WidgetState {
  website: string;
  websiteError: string;
  chatbotName: string;
  nameErr: string;
  chatlogo: File | null;
  listOfThemes: string[];
  selectedTheme: string;
  storedTheme: string;
}

const Widgets = (props: WidgesProps) => {
  const { isSettings } = props;
  const companyUuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');
  const navigate = useNavigate();
  const { menu } = getCustomMenuEffect(companyUuid ? companyUuid : '');

  const [isSubmit, setIsSubmit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [fileName, setFilename] = useState<string | null>(null);
  // const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // const [imageSrc, setImageSrc] = useState<string>('');
  // const [isCropOpen, setIsCropOpen] = useState<boolean>(false);

  const [state, setState] = useState<WidgetState>({
    website: '',
    websiteError: '',
    chatbotName: '',
    nameErr: '',
    chatlogo: null,
    listOfThemes: [
      '#3572EF',
      '#98ABEE',
      '#7776B3',
      '#1D24CA',
      '#9290C3',
      '#73EC8B',
      '#FF7F3E',
      '#6A1E55',
      '#E5D9F2'
    ],
    selectedTheme: '#D10707FF',
    storedTheme: '#D10707FF'
  });
  const [widgetUUID, setWidgetUUID] = useState('');
  const shopurl = sessionStorage.getItem('shopurl') || '';


  const handleState = (field: string, value: string | File) => {
    setState((prevState) => {
      let newState: any = { ...prevState };

      if (field === 'website') {
        newState[field] = value;
        // newState.websiteError = !websiteRegex.test(value) ? 'Please enter valid URL' : '';
        newState.websiteError =
          typeof value === 'string' && !websiteRegex.test(value) ? 'Please enter valid URL' : '';
      } else if (field === 'chatbotName') {
        newState[field] = value;
        newState.nameErr = value ? '' : 'Please enter name';
      } else if (field === 'chatlogo') {
        newState[field] = value;
        if (value instanceof File) {
          setImagePreview(URL.createObjectURL(value));
          setFilename(value.name);
        }
      } else {
        newState[field] = value;
      }

      return newState;
    });
  };

  // const handleCreateOrUpdateWidgets = async (e: any) => {
  //   try {
  //     if (
  //       state.chatbotName &&
  //       (businessType !== 'Retail' ? state.website && !state.websiteError : true)
  //     ) {
  //       setIsDisabled(true);
  //       let payload: any = {
  //         theme: state.selectedTheme,
  //         name: state.chatbotName,
  //         website: state.website,
  //         logo: state.chatlogo // Passing only file name
  //       };

  //       if (widgetUUID) {
  //         payload = { ...payload, uuid: widgetUUID };
  //         console.log('payload:', { ...payload });
  //       }

  //       const res = widgetUUID
  //         ? await updateWidgets(payload, companyUuid ? companyUuid : '')
  //         : await generateWidgets(payload, companyUuid ? companyUuid : '');

  //       if (res.message === 'Created' || res.message === 'Updated') {
  //         ToastNotification({
  //           message: res.message,
  //           type: 'success'
  //         });
  //         setIsDisabled(false);
  //         if (businessType === 'Retail' && !isSettings) {
  //           navigate('/account-setup/integration');
  //         }
  //         if (businessType !== 'Retail') {
  //           setIsSubmit(true);
  //         }
  //       } else {
  //         ToastNotification({
  //           message: res.message,
  //           type: 'error'
  //         });
  //         setIsDisabled(false);
  //       }
  //     } else {
  //       handleState('nameErr', state.chatbotName ? state.nameErr : 'Please enter name');
  //       handleState('websiteError', state.website ? state.websiteError : 'Please enter URL');
  //     }
  //   } catch {
  //     setIsDisabled(false);
  //   }
  // };

  const handleCreateOrUpdateWidgets = async (e: any) => {
    try {
      if (
        state.chatbotName &&
        ((businessType !== 'Retail' && businessType !== "WordpressRetail" && businessType !== "OdooRetail") ? state.website && !state.websiteError : true)
      ) {
        setIsDisabled(true);
        let formData = new FormData();

        // Append widget data (non-file data)
        formData.append('theme', state.selectedTheme);
        formData.append('name', state.chatbotName);
        formData.append('website', state.website);

        // Append logo (file) if available
        if (state.chatlogo) {
          formData.append('document', state.chatlogo, state.chatlogo.name);
        }

        // Include uuid if updating existing widget
        if (widgetUUID) {
          formData.append('uuid', widgetUUID);
        }

        const res = widgetUUID
          ? await updateWidgets(formData, companyUuid ? companyUuid : '')
          : await generateWidgets(formData, companyUuid ? companyUuid : '');

        if (res.message === 'Created' || res.message === 'Updated') {
          ToastNotification({
            message: res.message,
            type: 'success'
          });
          setIsDisabled(false);
          if (businessType === 'Retail' && !isSettings) {
            navigate('/account-setup/integration');
          }
          if (businessType === "WordpressRetail" || businessType === "OdooRetail" && !isSettings) {
            window.location.href = shopurl;
            console.log("Navigating to shopurl:", shopurl);
            // navigate("/dashboard")
          }
          if (businessType !== 'Retail' && businessType !== 'WordpressRetail' && businessType !== 'OdooRetail') {
            setIsSubmit(true);
          }
        } else {
          ToastNotification({
            message: res.message,
            type: 'error'
          });
          setIsDisabled(false);
        }
      } else {
        handleState('nameErr', state.chatbotName ? state.nameErr : 'Please enter name');
        handleState('websiteError', state.website ? state.websiteError : 'Please enter URL');
      }
    } catch {
      setIsDisabled(false);
    }
  };

  const fetchWidgetInfo = async () => {
    try {
      const res = await getWidgetsInfo(companyUuid ? companyUuid : '');

      if (res.message === 'Successful') {
        if (res.payload.uuid !== null) {
          setWidgetUUID(res.payload.uuid);

          setState({
            ...state,
            website: res?.payload?.widges?.website,
            selectedTheme: res?.payload?.widges?.colorTheme,
            chatbotName: res?.payload?.widges?.name,
            storedTheme: res?.payload?.widges?.colorTheme
          });

          const chatlogoUrl = res?.payload?.widges?.logo;
          if (chatlogoUrl) {
            const logo = await getLogo(chatlogoUrl);
            if (logo !== null) {
              setImagePreview(logo?.url);
              setFilename(chatlogoUrl);
            }
          }
        }
      }
    } catch (error) { }
  };
  useEffect(() => {
    fetchWidgetInfo();
  }, []);

  // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;

  //   const allowedTypes = [
  //     'image/jpeg',
  //     'image/png',
  //     'image/gif',
  //     'image/webp',
  //     'image/svg+xml',
  //     'image/x-icon'
  //   ];

  //   if (!allowedTypes.includes(file.type)) {
  //     alert('Invalid file type. Please upload a valid image.');
  //     return;
  //   }

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     setImageSrc(reader.result as string);
  //     setSelectedFile(file);
  //     setFilename(file.name);
  //     setIsCropOpen(true); // open crop modal
  //   };
  //   reader.readAsDataURL(file);
  // };

  // const handleCropComplete = async (croppedDataUrl: string) => {
  //   // Convert base64 to File
  //   const blob = await (await fetch(croppedDataUrl)).blob();
  //   const file = new File([blob], 'cropped-image.jpg', { type: blob.type });

  //   setImagePreview(croppedDataUrl); // optional preview
  //   handleState('chatlogo', file); // ✅ pass File to state
  // };

  return (
    <CreateWidgets
      state={state}
      isSubmit={isSubmit}
      isDisabled={isDisabled}
      setIsSubmit={setIsSubmit}
      handleState={handleState}
      handleCreateOrUpdateWidgets={handleCreateOrUpdateWidgets}
      imagePreview={imagePreview}
      fileName={fileName}
      isSettings={isSettings}
      // handleFileChange={handleFileChange}
      // handleCropComplete={handleCropComplete}
      // isCropOpen={isCropOpen}
      // imageSrc={imageSrc}
      // setIsCropOpen={setIsCropOpen}
      menu={menu}
    />
  );
};

export default Widgets;
